import "./GetInTouch.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Application from "./sections/Application";
import Location from "./sections/Location";
import Footer from "@/reusable_sections/Footer";
export default function GetInTouchPage() {
  return <div>
      <Navigation />
      <Contact />
      <Application />
      <Location />
      <Footer />
    </div>;
}